import axios from "@/api/axios";
import store from "@/store";
import _ from "lodash";
import qs from "qs";

// 회원정보보기
const get_owneview = async (result) => {
  let finalData = {
    code: 200,
    message: "Ok",
    owneview: {
      id: "",
      nickname: "",
      email: "",
      membertype: "",
      timezone: "",
      daylighttime: "",
      fieldunit: "",
      greenunit: "",
      speedunit: "",
      emailagree: "",
      firstname: "",
      lastname: "",
      state: "",
      city: "",
      address: "",
      zipcode: "",
      phone: "",
      fax: "",
      website: "",
      address_lat: "",
      address_lng: "",
    },
  };
  const token = sessionStorage.getItem("token") || null;

  const options = {
    method: "GET",
    url: "/membership/ownerview",
    headers: { Authorization: "Bearer " + token },
  };

  try {
    await axios(options).then((response) => {
      if (response.data.code === 200) {
        finalData = _.merge(finalData, response.data);
        result(true, finalData);
      } else {
        console.error(response.data.code, response.data.message);
        result(false, response.data.message);
      }
    });
  } catch (err) {
    console.error("get_owneview", err);
    result(false, err);
  }
};

// 비밀번호 수정
const set_ownerchangepwd = async (form, result) => {
  const token = sessionStorage.getItem("token") || null;

  const options = {
    method: "POST",
    url: "/setting/changepwd",
    headers: { Authorization: "Bearer " + token },
    data: qs.stringify({
      curpassword: form.curpassword,
      newpassword: form.newpassword,
      newpassword_re: form.newpassword_re,
    }),
  };

  try {
    await axios(options).then((response) => {
      if (response.data.code === 200) {
        result(true, response.data);
      } else {
        console.error(response.data.code, response.data.message);
        result(false, response.data);
      }
    });
  } catch (err) {
    console.error("set_ownerchangepwd", err);
    result(false, err);
  }
};

// 이메일 수정
const set_ownerchangeemail = async (form, result) => {
  const token = sessionStorage.getItem("token") || null;

  const options = {
    method: "POST",
    url: "/setting/changeemail",
    headers: { Authorization: "Bearer " + token },
    data: qs.stringify({
      curemail: form.curemail,
      newemail: form.newemail,
      newemail_re: form.newemail_re,
    }),
  };

  try {
    await axios(options).then((response) => {
      if (response.data.code === 200) {
        result(true, response.data);
      } else {
        console.error(response.data.code, response.data.message);
        result(false, response.data);
      }
    });
  } catch (err) {
    console.error("set_ownerchangeemail", err);
    result(false, err);
  }
};

// 매장옵션보기
const get_owneroptionview = async (result) => {
  let finalData = {
    code: 200,
    message: "Ok",
    owneroptionview: {
      tournamentopt: "",
      eventopt: "",
      bookingopt: "",
      salesstarttime: "",
      salesdeadline: "",
    },
  };
  const token = sessionStorage.getItem("token") || null;

  const options = {
    method: "GET",
    url: "/setting/owneroptionview",
    headers: { Authorization: "Bearer " + token },
  };

  try {
    await axios(options).then((response) => {
      if (response.data.code === 200) {
        finalData = _.merge(finalData, response.data);
        result(true, finalData);
      } else {
        console.error(response.data.code, response.data.message);
        result(false, response.data);
      }
    });
  } catch (err) {
    console.error("get_owneroptionview", err);
    result(false, err);
  }
};

// 매장옵션 수정
const set_owneroption = async (form, result) => {
  const token = sessionStorage.getItem("token") || null;

  const options = {
    method: "POST",
    url: "/setting/owneroption",
    headers: { Authorization: "Bearer " + token },
    data: qs.stringify({
      tournamentopt: form.tournamentopt,
      eventopt: form.eventopt,
      bookingopt: form.bookingopt,
      salesstarttime: form.salesstarttime,
      salesdeadline: form.salesdeadline,
    }),
  };

  try {
    await axios(options).then((response) => {
      if (response.data.code === 200) {
        result(true, response.data);
      } else {
        console.error(response.data.code, response.data.message);
        result(false, response.data);
      }
    });
  } catch (err) {
    console.error("set_ownerchangeemail", err);
    result(false, err);
  }
};

// 공지사항리스트
const get_ownernoticelist = async (param, result) => {
  let finalData = {
    code: 200,
    message: "Ok",
    noticelistcnt: 0,
    noticelist: [],
  };
  const token = sessionStorage.getItem("token") || null;

  const options = {
    method: "GET",
    url: "/setting/ownernoticelist",
    headers: { Authorization: "Bearer " + token },
    params: {
      searchtype: param.searchtype,
      searchname: param.searchname,
      pageno: param.pageno,
    },
  };

  try {
    await axios(options).then((response) => {
      if (response.data.code === 200) {
        finalData = _.merge(finalData, response.data);
        result(true, finalData);
      } else {
        console.error(response.data.code, response.data.message);
        result(false, response.data.message);
      }
    });
  } catch (err) {
    console.error("get_ownernoticelist", err);
    result(false, err);
  }
};

// 공지사항상세보기
const get_ownernoticeview = async (noticeno, searchdata, result) => {
  let finalData = {
    code: 200,
    message: "Ok",
    noticeview: [
      {
        type: "",
        title: "",
        date: "",
        cnt: "",
        contents: "",
      },
    ],
  };
  const token = sessionStorage.getItem("token") || null;

  const options = {
    method: "GET",
    url: "/setting/ownernoticeview/" + noticeno,
    headers: { Authorization: "Bearer " + token },
    params: {
      searchtype: searchdata.searchtype,
      searchname: searchdata.searchname,
    },
  };

  try {
    await axios(options).then((response) => {
      if (response.data.code === 200) {
        finalData = _.merge(finalData, response.data);
        result(true, finalData);
      } else {
        console.error(response.data.code, response.data.message);
        result(false, response.data);
      }
    });
  } catch (err) {
    console.error("get_ownernoticeview", err);
    result(false, err);
  }
};

// 지역리스트(주)
const get_stateslist = async (countryno, result) => {
  let finalData = {
    code: 200,
    message: "Ok",
    stateslistcnt: 0,
    stateslist: [],
  };

  const options = {
    method: "GET",
    url: "/common/stateslist/" + countryno,
  };

  try {
    await axios(options).then((response) => {
      if (response.data.code === 200) {
        finalData = _.merge(finalData, response.data);
        result(true, finalData);
      } else {
        console.error(response.data.code, response.data.message);
        result(false, response.data.message);
      }
    });
  } catch (err) {
    console.error("get_stateslist", err);
    result(false, err);
  }
};

// 지역리스트(주)
const get_citylist = async (statesname, result) => {
  let finalData = {
    code: 200,
    message: "Ok",
    citylistcnt: 0,
    citylist: [],
  };

  const options = {
    method: "GET",
    url: "/common/citylist/" + statesname,
  };

  try {
    await axios(options).then((response) => {
      if (response.data.code === 200) {
        finalData = _.merge(finalData, response.data);
        result(true, finalData);
      } else {
        console.error(response.data.code, response.data.message);
        result(false, response.data.message);
      }
    });
  } catch (err) {
    console.error("get_citylist", err);
    result(false, err);
  }
};

// 매장 정보수정
const set_owneredit = async (form, result) => {
  const token = sessionStorage.getItem("token") || null;

  const data = new FormData();

  for (let key in form) {
    if (Array.isArray(form[key])) {
      form[key].forEach((v) => data.append(key + "[]", v));
    } else {
      data.append(key, form[key]);
    }
  }

  const options = {
    method: "POST",
    url: "/setting/owneredit",
    headers: { Authorization: "Bearer " + token },
    data: data,
  };
  // console.log(form.address_lat)
  try {
    await axios(options).then((response) => {
      // console.log(response.data)
      if (response.data.code === 200) {
        result(true, response.data);
      } else {
        console.error(response.data.code, response.data.message);
        result(false, response.data);
      }
    });
  } catch (err) {
    console.error("set_owneredit", err);
    result(false, err);
  }
};

// 지역좌표
const address_check = async (addresslist, result) => {
  let finalData = {
    code: 200,
    message: "Ok",
    addressinfo: [],
  };

  const options = {
    method: "POST",
    url: "/common/ajax_address_check",
    data: qs.stringify({
      addresslist: addresslist,
    }),
  };

  try {
    await axios(options).then((response) => {
      if (response.data.code === 200) {
        finalData = _.merge(finalData, response.data);
        result(true, finalData);
      } else {
        console.error(response.data.code, response.data.message);
        result(false, response.data);
      }
    });
  } catch (err) {
    console.error("address_check", err);
    result(false, err);
  }
};

// 타임존리스트(주)
const get_timezonelist = async (result) => {
  let finalData = {
    code: 200,
    message: "Ok",
    stateslistcnt: 0,
    stateslist: [],
  };

  const options = {
    method: "GET",
    url: "/common/timezonelist",
  };

  try {
    await axios(options).then((response) => {
      if (response.data.code === 200) {
        finalData = _.merge(finalData, response.data);
        result(true, finalData);
      } else {
        console.error(response.data.code, response.data.message);
        result(false, response.data.message);
      }
    });
  } catch (err) {
    console.error("get_timezonelist", err);
    result(false, err);
  }
};

// 나라리스트
const get_countrylist = async (result) => {
  let finalData = {
    code: 200,
    message: "Ok",
    countrylist: [],
  };

  const options = {
    method: "GET",
    url: "/common/countrylist",
  };

  try {
    await axios(options).then((response) => {
      if (response.data.code === 200) {
        finalData = _.merge(finalData, response.data);
        result(true, finalData);
      } else {
        console.error(response.data.code, response.data.message);
        result(false, response.data.message);
      }
    });
  } catch (err) {
    console.error("get_countrylist", err);
    result(false, err);
  }
};

export default {
  get_owneview,
  set_ownerchangepwd,
  set_ownerchangeemail,
  get_owneroptionview,
  set_owneroption,
  get_ownernoticelist,
  get_ownernoticeview,
  get_stateslist,
  get_citylist,
  address_check,
  set_owneredit,
  get_countrylist,
  get_timezonelist,
};
